// extracted by css-extract-rspack-plugin
export default {"wrap":"Delete__wrap--G1rvl","delete":"Delete__delete--YwoPk","icon":"Delete__icon--tUDlk","text":"Delete__text--lPier","warningText":"Delete__warningText--caTqH"};